<script setup lang="ts">
import { SIZES, type TSizes } from '@/ui/ts/types/Sizes'

const props = withDefaults(
    defineProps<{
        message: string
        disabled?: boolean
        lineClamp?: boolean
        size?: TSizes
    }>(),
    {
        lineClamp: true,
        size: SIZES.XSMALL,
    },
)

interface TSizeOptionClasses {
    paragraph: string
}

const sizes: Record<TSizes, TSizeOptionClasses> = {
    [SIZES.XSMALL]: {
        paragraph: /* tw */ 'paragraph-xs',
    },
    [SIZES.SMALL]: {
        paragraph: /* tw */ 'paragraph-sm',
    },
    [SIZES.MEDIUM]: {
        paragraph: /* tw */ 'paragraph-md',
    },
    [SIZES.LARGE]: {
        paragraph: /* tw */ 'paragraph-lg',
    },
}

const size = sizes[props.size]
</script>

<template>
    <span
        class="text-neutral-tertiary"
        :class="[
            size.paragraph,
            {
                'line-clamp-2': lineClamp,
                '!text-disabled pointer-events-none !cursor-not-allowed select-none': disabled,
            },
        ]"
    >
        {{ message }}
    </span>
</template>
